import React from 'react';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ChatCanvasHeaderProps {
  itemCount: number;
  onClose: () => void;
}

export const ChatCanvasHeader: React.FC<ChatCanvasHeaderProps> = ({ itemCount, onClose }) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between px-6 py-4">
      <div>
        <h2 className="text-lg font-semibold">{t('sources') || 'Canvas'}</h2>
        <p className="text-xs text-gray-500">{itemCount} {t('items') || 'items'}</p>
      </div>
      <button
        onClick={onClose}
        className="p-1.5 rounded-lg transition-colors"
      >
        <X size={20} className="text-gray-600" />
      </button>
    </div>
  );
};
